import React, {useState, useEffect, useCallback} from 'react'

import BrassPanel from '../../../components/BrassPanel'

function MachineSwitches({switchImg, switchIcon, variation, setPlayerInput, overheating, resetGame}) {
    const [switchValue, setSwitchValue] = useState([0, 0, 0, 0, 0, 0])
    const [classStr, setClassStr] = useState('')
    const [defaultBackground] = useState('rgba(217, 193, 156, 1)')
    const [backgroundColor, setBackgroundColor] = useState(defaultBackground)
        
    function handleSwitchChange(event) {
        const {value, name} = event.target
        const newArr = [...switchValue]
        newArr[name] = value
        setSwitchValue(newArr)
        updatePlayerInput(newArr)
    }
    
    const updatePlayerInput = useCallback((newArr) => {
        setPlayerInput(prevInput => {
            return ({
                ...prevInput,
                switches: newArr.join('')
            })
        })
    }, [setPlayerInput])
    
    useEffect(() => {
        if (resetGame) {
            const resetArr = [0, 0, 0, 0, 0, 0]
            setSwitchValue(resetArr)
            updatePlayerInput(resetArr)
        } 
    }, [resetGame, updatePlayerInput])
    
    useEffect(() => {
        if (overheating) {
            !classStr && setClassStr('machine_display-switches-overheat')
            setTimeout(() => {
                backgroundColor === defaultBackground ?
                    setBackgroundColor('firebrick') : setBackgroundColor(defaultBackground)
            }, 500)
        } else {
            classStr && setClassStr('')
            backgroundColor !== defaultBackground && setBackgroundColor(defaultBackground)
        }
        
    }, [overheating, backgroundColor, classStr, defaultBackground])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-switches'>
            <div className='switches_displayContainer'>
                <div className={`machine_display machine_display-switches ${classStr}`} style={{background: backgroundColor}}>
                    {!resetGame && switchImg && !overheating &&
                        <img className='switches_img' src={switchImg} alt='chess piece' />
                    }
                </div>
                <div className={`machine_display machine_display-switches ${classStr}`} style={{background: backgroundColor}}>
                    {!resetGame && switchIcon && !overheating &&
                        <i className={switchIcon[variation]}></i>
                    }
                </div>
            </div>
            <div className='machine_switchesContainer'>
                {switchValue.map((value, index) => {
                    return (
                        <input
                            key={index}
                            type='range'
                            className='machine_switch'
                            min='0'
                            max='1'
                            name={index}
                            value={value}
                            onChange={handleSwitchChange}
                        />
                    )
                })}
            </div>
        </BrassPanel>
    )
}

export default MachineSwitches